import "./constants.mjs";
//#region src/utils/format.ts
const ELLIPSIS = "…";
function formatAddress(address) {
	if (address.length <= 6) return address;
	const offset = address.startsWith("0x") ? 2 : 0;
	return `0x${address.slice(offset, offset + 4)}${ELLIPSIS}${address.slice(-4)}`;
}
function formatDigest(digest) {
	return `${digest.slice(0, 10)}${ELLIPSIS}`;
}
const AMOUNT_REGEX = /^-?(?:[0-9]+(?:\.[0-9]+)?|\.[0-9]+)$/;
/** Parse a decimal string into its smallest-unit bigint representation. No floating point. */
function parseToUnits(amount, decimals) {
	if (decimals < 0 || !Number.isInteger(decimals)) throw new Error(`Invalid decimals: ${decimals}`);
	if (!AMOUNT_REGEX.test(amount)) throw new Error(`Invalid amount: "${amount}"`);
	const negative = amount.startsWith("-");
	const [whole, fraction = ""] = (negative ? amount.slice(1) : amount).split(".");
	if (fraction.length > decimals) throw new Error(`Too many decimal places: "${amount}" has ${fraction.length} but max is ${decimals}`);
	const paddedFraction = fraction.padEnd(decimals, "0") || "0";
	const result = BigInt(whole || "0") * 10n ** BigInt(decimals) + BigInt(paddedFraction);
	return negative ? -result : result;
}
/** Parse a SAFE decimal string into SAFELET. */
function parseToSafelet(amount) {
	return parseToUnits(amount, 9);
}
//#endregion
export { formatAddress, formatDigest, parseToSafelet, parseToUnits };

//# sourceMappingURL=format.mjs.map